import React from 'react'
import classNames from 'classnames'
import { Button, ButtonVariant } from '@/atoms/Button'
import { LinkPlusIcon } from '@/atoms/Icons/LinkPlusIcon'
import { HeadingLG, LabelLG, ParagraphMD } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { BitAngelPlayer } from '@/organisms/BitAngelPlayer'
import { PifVideoPlayerUI } from '@/organisms/BitAngelPlayer/PifVideoPlayerUI'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

interface AmbassadorVideoCardProps {
  title?: string
  description?: string
  onClick?: () => void
  videoUrl?: string
  showButton: boolean
  onVideoCopied: (videoId: string) => void
  sys?: {
    id?: string
  }
}

export const AmbassadorVideoCard: React.FC<AmbassadorVideoCardProps> = ({
  title,
  description,
  videoUrl,
  showButton,
  onVideoCopied,
  sys,
}) => {
  const { t } = useTranslate('ambassador')
  const track = useSafeTrack()
  const buttonText = t('shareVideo', 'Share Video')

  const trackVideoStart = () => {
    track('Video Content Started', {
      title,
      program: slugs.cabrini,
      video_type: 'video',
    })
  }

  const trackVideoCompleted = () => {
    track('Video Content Completed', {
      title,
      program: slugs.cabrini,
      video_type: 'video',
    })
  }

  return (
    <>
      <div className="flex flex-col gap-6 text-left">
        {videoUrl && (
          <BitAngelPlayer
            autoplay={false}
            className={classNames('aspect-h-5 aspect-w-4 relative z-10 overflow-hidden rounded-2xl', {})}
            ui={PifVideoPlayerUI}
            url={videoUrl}
            onStart={trackVideoStart}
            onPlaybackFinished={trackVideoCompleted}
          />
        )}
        <div className="flex flex-col gap-2">
          <HeadingLG className="text-white">{title}</HeadingLG>
          <ParagraphMD className="!weight-[350] text-core-gray-300">{description}</ParagraphMD>
        </div>
        {showButton && (
          <Button
            className="w-fit border-0 !bg-core-gray-900 px-7 py-[17px] transition-all duration-300 ease-in-out hover:!bg-core-gray-800"
            onClick={() => onVideoCopied(sys?.id ?? '')}
            variant={'core-gray-900' as ButtonVariant}
          >
            <span className="mr-2">
              <LinkPlusIcon size={28} color="white" />
            </span>
            <LabelLG>{buttonText}</LabelLG>
          </Button>
        )}
      </div>
    </>
  )
}
